/* ==========================================================================
   POLYMERCRAFTS — RELATED PRODUCTS PDP CAROUSEL JS CONTROLLER
   File: assets/related-products-pdp.js
   Description: Controls smooth chevron navigation, mouse drag, touch swipe, 
   and auto-slide behavior for the related products PDP carousel.
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function () {
  initRelatedProductsPdpCarousels();
});

// Shopify Theme Editor Section Load Event Support
document.addEventListener('shopify:section:load', function (event) {
  initRelatedProductsPdpCarousels(event.target);
});

function initRelatedProductsPdpCarousels(scope = document) {
  const relatedSections = scope.querySelectorAll('.sec__pc-related-products-pdp');

  relatedSections.forEach((section) => {
    const track = section.querySelector('.pc-related-track');
    const prevBtn = section.querySelector('.pc-slider-prev');
    const nextBtn = section.querySelector('.pc-slider-next');

    if (!track) return;

    let isDown = false;
    let startX;
    let scrollLeft;
    let autoplayTimer = null;

    const enableAutoplay = section.dataset.autoplay === 'true';
    const autoplaySpeed = (parseInt(section.dataset.autoplaySpeed, 10) || 4) * 1000;

    // Chevron Arrow Controls
    if (prevBtn) {
      prevBtn.addEventListener('click', () => {
        slideTrack(-1);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', () => {
        slideTrack(1);
      });
    }

    function slideTrack(direction) {
      const firstCard = track.querySelector('.pc-rel-card');
      if (!firstCard) return;

      const cardWidth = firstCard.offsetWidth + 20; // card width + gap
      track.scrollBy({ left: direction * cardWidth, behavior: 'smooth' });
    }

    // Mouse Drag Scrolling
    track.addEventListener('mousedown', (e) => {
      isDown = true;
      track.classList.add('is-dragging');
      startX = e.pageX - track.offsetLeft;
      scrollLeft = track.scrollLeft;
      stopAutoplay();
    });

    track.addEventListener('mouseleave', () => {
      isDown = false;
      track.classList.remove('is-dragging');
      startAutoplay();
    });

    track.addEventListener('mouseup', () => {
      isDown = false;
      track.classList.remove('is-dragging');
      startAutoplay();
    });

    track.addEventListener('mousemove', (e) => {
      if (!isDown) return;
      e.preventDefault();
      const x = e.pageX - track.offsetLeft;
      const walk = (x - startX) * 1.5;
      track.scrollLeft = scrollLeft - walk;
    });

    // Touch Events for Mobile
    track.addEventListener('touchstart', () => {
      stopAutoplay();
    }, { passive: true });

    track.addEventListener('touchend', () => {
      startAutoplay();
    }, { passive: true });

    // Hover Pause Handling
    section.addEventListener('mouseenter', () => {
      stopAutoplay();
    });

    section.addEventListener('mouseleave', () => {
      startAutoplay();
    });

    // Auto-Slide Logic
    function startAutoplay() {
      if (!enableAutoplay || autoplayTimer !== null) return;

      autoplayTimer = setInterval(() => {
        const firstCard = track.querySelector('.pc-rel-card');
        if (!firstCard) return;

        const cardWidth = firstCard.offsetWidth + 20;
        const maxScroll = track.scrollWidth - track.clientWidth;

        if (track.scrollLeft + cardWidth >= maxScroll - 10) {
          track.scrollTo({ left: 0, behavior: 'smooth' });
        } else {
          track.scrollBy({ left: cardWidth, behavior: 'smooth' });
        }
      }, autoplaySpeed);
    }

    function stopAutoplay() {
      if (autoplayTimer !== null) {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }
    }

    // Initialize Autoplay on page load
    if (enableAutoplay) {
      startAutoplay();
    }
  });
}
